<template>
    <GDialog
        v-model="modalStore.changePasswordModal.show"
        max-width="500"
        border-radius="10"
        @update:model-value="hideModal"
    >
        <div class="change-password-modal">
            <div class="modal-header">
                <div class="text-h3 text-bold text-center">Зміна пароля</div>
            </div>

            <div class="modal-body">
                <InputComponent
                    v-model="passwordData.current_password"
                    label="Поточний пароль"
                    placeholder="Поточний пароль"
                    type="password"
                    :errors="v$.passwordData.current_password.$errors"
                />
                <InputComponent
                    v-model="passwordData.password"
                    label="Новий пароль"
                    placeholder="Новий пароль"
                    type="password"
                    :errors="v$.passwordData.password.$errors"
                />
                <InputComponent
                    v-model="passwordData.password_confirmation"
                    label="Підтвердження пароля"
                    placeholder="Підтвердження пароля"
                    type="password"
                    :errors="v$.passwordData.password_confirmation.$errors"
                />
            </div>

            <div class="modal-buttons">
                <div class="container">
                    <ButtonComponent btn-style="grey" text="Скасувати" @click="hideModal" />
                    <ButtonComponent
                        btn-style="gradient"
                        text="Змінити пароль"
                        :disabled="!isPasswordDataFilled || submitting"
                        @click="changePassword"
                    />
                </div>
            </div>
        </div>
    </GDialog>
</template>

<script>
import ButtonComponent from '@/components/ButtonComponent.vue'
import InputComponent from '@/components/form/InputComponent.vue'
import { useModalStore } from '@/stores/index.js'
import { useVuelidate } from '@vuelidate/core'
import { helpers, maxLength, minLength, required, sameAs } from '@vuelidate/validators'
import fetchWrapper from '@/helpers/fetch-wrapper.js'

export default {
    name: 'ChangePasswordModal',
    components: { ButtonComponent, InputComponent },
    setup() {
        const modalStore = useModalStore()
        const v$ = useVuelidate({ $scope: false })

        return { modalStore, v$ }
    },
    data() {
        return {
            submitting: false,
            passwordData: {
                current_password: '',
                password: '',
                password_confirmation: ''
            }
        }
    },
    validations() {
        return {
            passwordData: {
                current_password: {
                    required: helpers.withMessage("Поточний пароль є обов'язковим", required)
                },
                password: {
                    required: helpers.withMessage("Новий пароль є обов'язковим", required),
                    min: helpers.withMessage('Пароль має містити щонайменше 8 символів', minLength(8)),
                    max: helpers.withMessage('Пароль занадто довгий', maxLength(255))
                },
                password_confirmation: {
                    required: helpers.withMessage("Підтвердження пароля є обов'язковим", required),
                    sameAs: helpers.withMessage(
                        'Паролі не співпадають',
                        sameAs(this.passwordData.password)
                    )
                }
            }
        }
    },
    computed: {
        isPasswordDataFilled() {
            return (
                this.passwordData.current_password?.length &&
                this.passwordData.password?.length &&
                this.passwordData.password_confirmation?.length
            )
        }
    },
    watch: {
        'modalStore.changePasswordModal.show'(val) {
            if (!val) {
                this.resetPasswordData()
            }
        }
    },
    methods: {
        resetPasswordData() {
            this.passwordData = {
                current_password: '',
                password: '',
                password_confirmation: ''
            }
            this.submitting = false
            this.v$.passwordData.$reset()
        },

        hideModal() {
            this.modalStore.changePasswordModal.show = false
            this.resetPasswordData()
        },

        changePassword() {
            this.v$.passwordData.$touch()
            if (this.v$.passwordData.$invalid) {
                return
            }

            this.submitting = true

            fetchWrapper
                .patch('/personal-cabinet/update-password', this.passwordData)
                .then((response) => {
                    this.$toast.success(response.message || 'Пароль оновлено успішно')
                    this.hideModal()
                })
                .finally(() => {
                    this.submitting = false
                })
        }
    }
}
</script>

<style scoped lang="scss">
.change-password-modal {
    padding: 2rem 0;

    .modal-header {
        margin-bottom: 1.5rem;
    }

    .button-component {
        width: 100% !important;
    }
}

.modal-buttons .container {
    gap: 1rem;
}
</style>
